import { COMMENTS_ENABLED } from '@/client/confs/app';
import { combine } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export type SellParams = { marketAddress: string; optionAddress: string };
export type RepliesOpenParams = { postUuid: string; total: number; lastId?: string };

// store
export const useModelStore = createWithEqualityFn(
  combine(
    {
      authOpen: false,
      sellOpen: false,
      sellParams: {
        marketAddress: '',
        optionAddress: '',
      } as SellParams,
      tradeOpen: false,
      searchOpen: false,
      repliesOpen: false,
      repliedParams: {
        postUuid: '',
        total: 0,
        lastId: '',
      } as RepliesOpenParams,
      walletOpen: false,
      depositOpen: false,
    },
    set => ({
      setAuthOpen: (authOpen: boolean) => set({ authOpen }),
      setSellOpen: (sellOpen: boolean) => set({ sellOpen }),
      setTradeOpen: (tradeOpen: boolean) => set({ tradeOpen }),
      setSellParams: (sellParams: SellParams) => set({ sellParams }),
      setSearchOpen: (searchOpen: boolean) => set({ searchOpen }),
      // Comments off (BON-248): opening the replies sidebar is a no-op.
      setRepliesOpen: (repliesOpen: boolean) => {
        if (repliesOpen && !COMMENTS_ENABLED) return;
        set({ repliesOpen });
      },
      setRepliedParams: (repliedParams: RepliesOpenParams) => set({ repliedParams }),
      setWalletOpen: (walletOpen: boolean) => set({ walletOpen }),
      setDepositOpen: (depositOpen: boolean) => set({ depositOpen }),
    })
  ),
  shallow
);
